import React from 'react';
import clsx from 'clsx';
import { renderedData } from '../../organisms/SearchResults/searchResultsMainComponent';
import { MemberExclusiveBannerConstants } from '../../organisms/SearchResults/index.constant';
import { MemberExclusiveBannerProps } from '../../organisms/SearchResults/index.types';

import { StyledMemberExclusiveBanner } from './index.styles';
import { useConditionalSearchResultsRenderedDataSERP } from '../../hooks/lib/useConditionalRenderedData';

export const MemberExclusiveBanner: React.FC<MemberExclusiveBannerProps> = ({ numberOfNights, pointsChecked }) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { isMapViewEnabled, jsonContent }: any = useConditionalSearchResultsRenderedDataSERP(renderedData);
  let labelText = '';

  if (numberOfNights === MemberExclusiveBannerConstants.fourNights && pointsChecked) {
    labelText = jsonContent.labelForFourNights;
  } else if (numberOfNights >= MemberExclusiveBannerConstants.fiveNights && pointsChecked) {
    labelText = jsonContent.labelForFiveOrMoreNights;
  }

  return (
    <StyledMemberExclusiveBanner>
      <div className={'member-exclusive-banner ' + (isMapViewEnabled ? `map-view pr-3` : ``)}>
        <div className={clsx('container', 'banner-container', isMapViewEnabled ? `map-banner` : `list-banner`)}>
          <div className="col m-icon-text banner-section" tabIndex={0} role="banner">
            <span className={clsx('card-icon-responsive', 'icon-inverse icon-extra-free-nights icon-holder')}></span>
            <div className="banner-label-container">
              <span className={clsx('t-subtitle-m', 'banner-label')}>{jsonContent.memberExclusiveLabel}</span>
              <span className={clsx('card-fs-s-to-xs', 'banner-text')}>{labelText}</span>
            </div>
          </div>
        </div>
      </div>
    </StyledMemberExclusiveBanner>
  );
};
